<template>
	<div>
		<div class="c-controls__group">
			<label class="c-controls__label">Team</label>
			<select v-model="team" v-on:change="chooseTeam()">
				<option v-for="team in teams" :key="team.uuid" :value="team.uuid">
					{{ team.name }}
				</option>
			</select>
		</div>
		<TimerControl @subcommand="subcommand" v-if="slide.settings.timer"></TimerControl>
	</div>
</template>

<script>
import BaseSlide from './BaseSlide';
import TimerControl from '../controls/TimerControl';

export default {
	name: 'PitchSlide',
	mixins: [BaseSlide],
	components: {
		TimerControl,
	},
	data() {
		return {
			team: this.$actions.getVariable('pitch.team'),
		};
	},
	computed: {
		teams() {
			return this.$actions.getTeams();
		},
	},
	methods: {
		chooseTeam() {
			this.subcommand('timer.stop');

			this.subcommand('set-variable', {
        name: 'pitch.team',
        value: this.team,
      });
		},
	},
};
</script>

<style></style>
